<main>
  <section class="main">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-6 mb-5 mb-lg-0">
          <div class="section-title main mt-lg-4 pt-lg-2">
            <div class="alt">Academic and</div>
            extracurricular platform
          </div>
          <form [formGroup]="form" (ngSubmit)="onSignin()" class="form login-form">
            <div class="form-el">
              <input type="email" name="email" placeholder="Email" formControlName="email" />
            </div>
            <div class="form-el">
              <input type="password" name="password" placeholder="Password" formControlName="password" />
            </div>
            <div class="form-el">
              <button class="button" [disabled]="form.invalid">Sign in</button>
            </div>
            <div class="text">or</div>
            <div class="alt-btn-wrap d-flex">
              <button class="button alt alt-btn-item" (click)="onAppleSignin(); false">
                Continue with
                <svg viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6.15 16.82C3.62 16.8 1.53 11.64 1.53 9c0-4.3 3.22-5.24 4.46-5.24.56 0 1.16.22 1.69.42.37.13.75.27.96.27.13 0 .43-.12.7-.22.55-.23 1.25-.5 2.07-.5.62 0 2.46.13 3.57 1.8l.26.39-.37.28c-.54.4-1.51 1.14-1.51 2.6 0 1.73 1.1 2.4 1.63 2.71.24.14.48.29.48.6 0 .21-1.66 4.67-4.06 4.67-.6 0-1-.18-1.38-.33-.37-.16-.69-.3-1.22-.3-.27 0-.6.13-.96.27-.5.18-1.05.39-1.68.39h-.02Z"
                    fill="#000"
                  />
                  <path d="M11.67 0c.06 2.26-1.56 3.83-3.17 3.73C8.23 1.93 10.1 0 11.67 0Z" fill="#000" />
                </svg>
              </button>
              <button class="button alt alt-btn-item" (click)="onGoogleSignin(); false">
                Continue with
                <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="m3.55 9.67-.56 2.08-2.04.04A7.96 7.96 0 0 1 .9 4.32l1.82.33.8 1.8a4.76 4.76 0 0 0 .04 3.22Z"
                    fill="#FBBB00"
                  />
                  <path
                    d="M15.86 6.5a8.02 8.02 0 0 1-2.85 7.74l-2.28-.12-.33-2.02a4.77 4.77 0 0 0 2.05-2.43H8.18V6.5h7.68Z"
                    fill="#518EF8"
                  />
                  <path d="M13 14.24A8 8 0 0 1 .96 11.79l2.6-2.12a4.76 4.76 0 0 0 6.85 2.43l2.6 2.14Z" fill="#28B446" />
                  <path d="m13.1 1.84-2.59 2.12a4.76 4.76 0 0 0-7.01 2.5L.9 4.31a8 8 0 0 1 12.2-2.48Z" fill="#F14336" />
                </svg>
              </button>
            </div>
          </form>
        </div>
        <div class="col-12 col-lg-6">
          <div class="illustration">
            <svg viewBox="0 0 476 340" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="m9.73 340 131.18-.88 45-.02h14.91l45.1-.02 206.04-.06s47.14-60.92-3.2-118.77c-52.2-59.99-77.58-11.13-93.63-95.58C314.74-87.85-66.8-1.22 37.9 179.65 75.62 244.77-16.34 247.23 9.73 340Z"
                fill="#F3F3F3"
              />
              <path
                d="m145.41 289.54-.91-.51a2.05 2.05 0 0 1-.8-2.75l4.2-7.72a2.02 2.02 0 0 1 2.72-.81l1.31.71a.4.4 0 0 1-.39.7l-1.3-.72a1.22 1.22 0 0 0-1.67.5l-4.2 7.71c-.32.6-.12 1.36.48 1.68l.92.5c.6.33 1.34.12 1.66-.48l2.78-5.12a.4.4 0 0 1 .54-.15.4.4 0 0 1 .16.54l-2.79 5.13a1.98 1.98 0 0 1-2.7.79Z"
                fill="#A2C2D8"
              />
              <path
                d="m141.53 297.65-1.65-.9c-1.5-.85-2.03-2.86-1.13-4.5l6.31-11.62a.4.4 0 0 1 .54-.15.4.4 0 0 1 .15.54l-6.31 11.62c-.7 1.26-.32 2.79.82 3.43l1.64.9c1.14.63 2.62.12 3.3-1.14l7.2-13.22c.7-1.27.32-2.8-.82-3.43a.4.4 0 0 1-.15-.55.4.4 0 0 1 .54-.15c1.52.85 2.04 2.86 1.14 4.5l-7.2 13.22c-.9 1.64-2.87 2.28-4.38 1.45ZM306.84 177.61l.65-.47c.7-.49 1.66-.34 2.17.33l4.03 5.37c.5.69.37 1.64-.31 2.14l-.92.67a.3.3 0 0 1-.43-.07.3.3 0 0 1 .07-.42l.92-.67c.41-.31.5-.9.2-1.3l-4.04-5.38a.96.96 0 0 0-1.32-.2l-.65.47a.92.92 0 0 0-.2 1.3l2.68 3.56a.3.3 0 0 1-.07.42.3.3 0 0 1-.43-.07l-2.67-3.56a1.5 1.5 0 0 1 .32-2.12Z"
                fill="#A2C2D8"
              />
              <path
                d="m302.43 172.34 1.16-.85c1.08-.77 2.65-.48 3.5.66l6.06 8.07a.3.3 0 0 1-.06.42.3.3 0 0 1-.43-.07l-6.06-8.07c-.66-.88-1.85-1.11-2.66-.53l-1.16.84c-.8.59-.92 1.76-.26 2.64l6.9 9.2c.65.87 1.83 1.1 2.65.53.13-.1.32-.08.43.07a.3.3 0 0 1-.07.42c-1.08.77-2.65.48-3.5-.66l-6.9-9.19c-.85-1.15-.66-2.7.4-3.48Z"
                fill="#A2C2D8"
              />
              <path
                opacity=".6"
                d="M281.23 241.24H80.66c-4.92 0-8.93-3.84-8.93-8.59V70.93c0-4.73 3.99-8.59 8.93-8.59h200.57c4.92 0 8.94 3.84 8.94 8.59v161.75c0 4.73-4 8.57-8.94 8.57Z"
                fill="#fff"
              />
              <path
                d="M290.17 83.38H71.73V69.12a6.73 6.73 0 0 1 6.65-6.79h205.13a6.73 6.73 0 0 1 6.66 6.8v14.25Z"
                fill="#9CC0C7"
              />
              <path
                d="M80.2 72.91c0-1.37 1.1-2.48 2.46-2.48a2.47 2.47 0 0 1 2.47 2.48 2.47 2.47 0 1 1-4.93 0ZM90.58 72.91a2.47 2.47 0 1 1 4.93 0c0 1.38-1.1 2.49-2.46 2.49a2.47 2.47 0 0 1-2.47-2.49ZM100.97 72.91a2.47 2.47 0 1 1 4.93 0c0 1.38-1.1 2.49-2.46 2.49a2.47 2.47 0 0 1-2.47-2.49Z"
                fill="#FCFCFC"
              />
              <path
                opacity=".5"
                d="M140.72 102.1H98.7a10 10 0 0 0-10 10v42.52a10 10 0 0 0 10 10h42.02a10 10 0 0 0 10-10v-42.53a10 10 0 0 0-10-10Z"
                fill="#ECF2F5"
              />
              <path
                opacity=".5"
                d="M216.93 106.74H167.6a2.35 2.35 0 0 1-2.33-2.35c0-1.3 1.04-2.36 2.33-2.36h49.34a2.34 2.34 0 0 1 2.34 2.36c0 1.3-1.05 2.35-2.34 2.35ZM275.93 103.58h-49.34a2.35 2.35 0 0 1-2.34-2.36c0-1.3 1.05-2.35 2.34-2.35h49.34a2.35 2.35 0 0 1 2.33 2.35c0 1.3-1.04 2.36-2.33 2.36Z"
                fill="#A7CCCE"
              />
              <g opacity=".6" fill="#ADCCE1">
                <path
                  opacity=".3"
                  d="M226.68 124.94h-59.93c-.84 0-1.51-.68-1.51-1.53s.67-1.52 1.5-1.52h59.94c.84 0 1.51.67 1.51 1.52a1.5 1.5 0 0 1-1.5 1.53ZM249.47 124.94h-15.82c-.84 0-1.51-.68-1.51-1.53s.67-1.52 1.5-1.52h15.83c.84 0 1.52.67 1.52 1.52s-.68 1.53-1.52 1.53ZM189.37 134.45h-22.6c-.84 0-1.52-.68-1.52-1.53s.68-1.52 1.52-1.52h22.6a1.53 1.53 0 0 1 0 3.05ZM225.99 134.45h-30.98c-.83 0-1.5-.68-1.5-1.53s.67-1.52 1.5-1.52H226c.84 0 1.51.67 1.51 1.52.02.83-.67 1.53-1.51 1.53ZM249.47 134.45h-15.82c-.84 0-1.51-.68-1.51-1.53s.67-1.52 1.5-1.52h15.83a1.53 1.53 0 0 1 0 3.05ZM197.44 142.66h-30.67c-.84 0-1.52-.68-1.52-1.53s.68-1.53 1.52-1.53h30.67c.84 0 1.52.68 1.52 1.53 0 .83-.68 1.53-1.52 1.53ZM256.03 142.66h-50.18c-.84 0-1.51-.68-1.51-1.53s.67-1.53 1.51-1.53h50.18c.84 0 1.51.68 1.51 1.53 0 .83-.67 1.53-1.51 1.53Z"
                />
              </g>
              <g opacity=".6" fill="#ADCCE1">
                <path
                  opacity=".3"
                  d="M226.68 155.12h-59.93c-.84 0-1.51-.68-1.51-1.52 0-.85.67-1.53 1.5-1.53h59.94c.84 0 1.51.68 1.51 1.53.02.83-.67 1.52-1.5 1.52ZM249.47 155.12h-15.82c-.84 0-1.51-.68-1.51-1.52 0-.85.67-1.53 1.5-1.53h15.83a1.53 1.53 0 0 1 0 3.05ZM189.37 164.62h-22.6c-.84 0-1.52-.68-1.52-1.53s.68-1.53 1.52-1.53h22.6c.84 0 1.52.68 1.52 1.53s-.68 1.53-1.52 1.53ZM225.99 164.62h-30.98c-.83 0-1.5-.68-1.5-1.53s.67-1.53 1.5-1.53H226c.84 0 1.51.68 1.51 1.53a1.5 1.5 0 0 1-1.51 1.53Z"
                />
              </g>
              <path
                d="M116.51 111.41h6.41l17.3 39.93h-7.3l-4-9.57H110.3l-4.06 9.57h-7.08l17.34-39.93Zm9.88 24.19-6.8-15.86-6.74 15.86h13.55Z"
                fill="#D1E3E4"
              />
              <path
                d="M148.87 181.02h-58.4c-.8 0-1.44-.66-1.44-1.45 0-.81.66-1.45 1.44-1.45h58.4c.8 0 1.44.66 1.44 1.45 0 .8-.64 1.45-1.44 1.45ZM142.44 186.16h-52c-.8 0-1.44-.66-1.44-1.45 0-.81.66-1.45 1.44-1.45h52c.8 0 1.44.66 1.44 1.45.02.79-.63 1.45-1.44 1.45ZM125.52 191.52H90.44c-.8 0-1.44-.66-1.44-1.45 0-.81.66-1.45 1.44-1.45h35.08c.8 0 1.44.66 1.44 1.45.02.79-.64 1.45-1.44 1.45ZM125.93 212.57H91.38c-.8 0-1.43-.66-1.43-1.45 0-.81.65-1.45 1.43-1.45h34.55c.8 0 1.44.66 1.44 1.45 0 .79-.64 1.45-1.44 1.45ZM110.03 207.71H91.38c-.8 0-1.43-.66-1.43-1.45 0-.81.65-1.45 1.43-1.45h18.65c.8 0 1.44.66 1.44 1.45 0 .79-.63 1.45-1.44 1.45ZM142.44 217.78H91.3c-.8 0-1.44-.66-1.44-1.45 0-.81.65-1.45 1.44-1.45h51.15c.8 0 1.44.66 1.44 1.45.02.8-.63 1.45-1.44 1.45Z"
                fill="#DBF1F2"
              />
              <path
                d="M292.37 81.7s.9 10.84-1.55 10.67c-2.45-.16-7.29-4.93-17.06-4.16-9.77.78-21.7 2.94-28.92-9.94-7.21-12.88 9.23-16.6 9.23-16.6l38.3 20.03Z"
                fill="#5B777C"
              />
              <path d="m271.61 80.9 49.21 4.1 1.01-2.23-47.15-35.08-47.64-5.62-.92 1.98 45.5 36.86Z" fill="#4F676B" />
              <path
                d="M305.11 118.25a1.9 1.9 0 0 0-2.35-1.32 1.92 1.92 0 0 0 1.05 3.7c1-.29 1.58-1.36 1.3-2.38Z"
                fill="#FF886D"
              />
              <path
                d="M303.47 118.78c1.98-.15 2.43 17.94 2.43 17.94s-1.3.6-1.93.47c-.63-.15-.95-2.57-.95-2.57l-.06 2.56s-2.16.07-2.9-.46c0-.01.29-17.7 3.41-17.94Z"
                fill="#FF886D"
              />
              <path d="m304.1 119.2-.35-39.54-.26-.2-25.7-19.16-.9 1.27 25.42 18.96.58 38.59 1.21.07Z" fill="#FF886D" />
              <path
                d="M337.26 305.74H229.2v-41.39h108.43c8.76 0 15.86 7.16 15.86 15.99v9.04c0 9.04-7.25 16.36-16.22 16.36Z"
                fill="#FCECDB"
              />
              <path
                d="M446.2 281.38v6.23c0 3.33-.82 6.44-2.28 9.11-2.91 5.39-8.33 9.02-14.53 9.02H225.86c-1.34 0-2.42-1.18-2.42-2.63v-.94c0-1.45 1.08-2.64 2.42-2.64h124.07a17.9 17.9 0 0 0 3.55-10.73v-7.92a17.46 17.46 0 0 0-3.38-10.35H225.85c-1.35 0-2.43-1.19-2.43-2.64v-.92c0-1.45 1.08-2.64 2.43-2.64H430.4c7.2 0 13.28 5.22 15.17 12.34.43 1.5.63 3.08.63 4.7Z"
                fill="#47979D"
              />
              <path
                d="M445.58 276.69h-92.6a17 17 0 0 0-2.88-6.14H225.85c-1.35 0-2.43-1.19-2.43-2.64v-.92c0-1.45 1.08-2.64 2.43-2.64H430.4c7.23 0 13.3 5.22 15.19 12.34Z"
                fill="#39888E"
              />
              <path d="m229.19 285.05 15.08.7-15.08.4v-1.1ZM229.19 291.53l35.85.7-35.85.43v-1.13Z" fill="#F4D2B8" />
              <path
                d="M213.4 337.85h106.08v-32.2H212.45c-7.94 0-14.39 6.5-14.39 14.5v2.24c0 8.53 6.88 15.46 15.34 15.46Z"
                fill="#77B7BC"
              />
              <path
                d="M314.38 337.85h120.9v-32.2H314.05a14.69 14.69 0 0 0-14.63 14.75v2.35c0 8.34 6.7 15.1 14.97 15.1Z"
                fill="#FCECDB"
              />
              <path
                d="M291.42 337.85h147.94c1.23 0 2.22-1 2.22-2.24v-.34c0-1.24-.99-2.24-2.22-2.24H291.42c-1.24 0-2.23 1-2.23 2.24v.34c0 1.23 1 2.24 2.23 2.24ZM291.42 310.47h147.94c1.23 0 2.22-1 2.22-2.24v-.34c0-1.24-.99-2.24-2.22-2.24H291.42c-1.24 0-2.23 1-2.23 2.24v.34c0 1.22 1 2.24 2.23 2.24Z"
                fill="#77B7BC"
              />
              <path d="m435.29 321.75-16.48.53 16.48.34v-.87ZM435.29 314.33l-39.2.55 39.2.32v-.87Z" fill="#F4D2B8" />
              <path
                d="M396.5 314.76s1.68 1.38 2.24 3.66c.1.4.17.83.17 1.28.1 3.01 0 9.85 0 9.85l4.95-3.43 4.95 3.43v-9.27c0-1.75-.43-3.46-1.21-4.57-.38-.55-.84-.95-1.37-.95h-9.73Z"
                fill="#FFAC9A"
              />
              <path d="M396.5 314.76s1.68 1.38 2.24 3.66l9.94.13s-.39-3.26-2.44-3.79h-9.74Z" fill="#FF886D" />
              <path
                d="M306.32 264.43H201.91v-47.31h104.8c9.27 0 16.78 7.57 16.78 16.91v13.09c0 9.57-7.68 17.3-17.17 17.3Z"
                fill="#FCECDB"
              />
              <path
                d="M323.55 235.48v10.19c-.02 4.35-2.02 8.12-4.97 10.13a8.55 8.55 0 0 1-4.9 1.56H198.72c-1.34 0-2.44 1.32-2.44 2.94v1.2c0 1.63 1.08 2.94 2.44 2.94h198.63c5.7 0 10.75-3.4 13.79-8.62a23.01 23.01 0 0 0 3.05-11.62v-8.04c0-2.96-.56-5.76-1.57-8.27-2.56-6.36-7.96-10.75-14.24-10.75H198.71c-1.34 0-2.44 1.32-2.44 2.94v1.2c0 1.62 1.08 2.94 2.44 2.94h115.33a8.84 8.84 0 0 1 6.99 3.67c1.55 2 2.5 4.65 2.52 7.6Z"
                fill="#FFCA28"
              />
              <path
                d="M196.27 260.3v1.2c0 1.63 1.08 2.94 2.44 2.94h198.63c5.7 0 10.75-3.4 13.79-8.62H318.6a8.56 8.56 0 0 1-4.9 1.56H198.73c-1.36-.02-2.46 1.28-2.46 2.92Z"
                fill="#F1BB15"
              />
              <path d="m201.9 240.77 14.75.81-14.74.47v-1.28ZM201.9 229.89l35.08.8-35.07.48v-1.28Z" fill="#FFCA28" />
              <path
                d="M236.62 230.53s-2.31 1.5-3.08 3.97c-.13.44-.22.89-.24 1.38-.13 3.27 0 10.7 0 10.7l-6.84-3.72-6.82 3.71v-10.05c0-1.9.58-3.75 1.66-4.96.53-.58 1.16-1.03 1.89-1.03h13.43Z"
                fill="#FF886D"
              />
              <path d="M236.62 230.53s-2.31 1.5-3.08 3.97l-13.7.15s.55-3.52 3.37-4.1h13.41v-.02Z" fill="#FFAC9A" />
              <path
                d="M74.22 262.23s21.27 8 25.16 7.82c3.89-.17 27.82-7.34 27.82-7.34l-.62 4.14s-18.48 10.72-24.94 11.32c-6.35.6-28.1-5.74-30.2-7.1a5.07 5.07 0 0 1 2.78-8.84Z"
                fill="#D08976"
              />
              <path
                d="M76.7 271.1a20.68 20.68 0 0 1-7.2 3.08c-11.09 2.58-15.33-6.87-16.94-13.35a9.51 9.51 0 0 1 3.76-1.17c.8-.1 1.64-.15 2.33-.19 0-1.07 3.2-1.92 2.34-8.72l1.3.56 8.75 2.41-.2 2.72c-.15 2.07-.04 4.08.39 4.51.7.15.9.27.9.27.14.23 2.67 4.43 4.57 9.87Z"
                fill="#C17561"
              />
              <path d="M71.02 254.01s-.22 1.42-.22 5.67c-4.95-.51-7.63-4.63-8.53-7.23l8.75 1.56Z" fill="#A96654" />
              <path
                d="M71.48 256.63s-12.23-1.77-11.73-9.77c.53-8.02-.21-12.45 7.34-12.32 7.56.12 8.87 1.54 9.3 4.24.43 2.72-1.82 17.83-4.91 17.85Z"
                fill="#BC6F5B"
              />
              <path
                d="M56.34 236.23c-.1-.11-.35-.2-.9-.23 0 0 .44-.25 1.03-.25.12-.7.54-1.93 1.83-2.22 0 0-.71.35-.8 1.08 1.53-1.43 3.51-3.12 12.43-2.38 11.75.95 7.82 7.92 6.28 8.73-1.54.83-5.34-1.49-8.17-1.3-2.85.2-3.41 4-4.37 4.51-.95.52-.58-.4-1.87-.96-1.29-.56-1.43 1.44-1.08 2.76.37 1.31-.54 3.86-.54 3.86s.34-.18-1.45-2c-2.26-2.3-3.45-9.53-2.62-11.15.09-.14.15-.3.23-.45Z"
                fill="#1C2F36"
              />
              <path
                d="M41.37 289.43c1.16-8.5 1.28-12.2 3.41-25.06 2.28-4.63 3.84-6.05 14.84-6.05 1.67 1.1 8.02 5.18 10.62 4.67l.14-.04c1.24-.3 1.7-1.18.68-1.92 0 0 2.65-.26 5.94.36 1.87.36 6.87 2.98 6.87 2.98s-2.52 4.6-6.24 6.17c.64 5.71-.31 8.23-6.18 21.42-4.97 11.15.67 21.18.67 21.18s-33.16 31.28-33.3 19.21c-.16-9.1 1.49-35.1 2.55-42.93Z"
                fill="#FF886D"
              />
              <path
                d="M61.85 338.73c1.58-.2 6.84-1.53 10.66-7.23.15-.2.3-.43.45-.68 3.32-5.08 2.96-12.5 14.05-31.62 1.83-4.03 11.38-5.34 13.16-9.9 0 0 4.39-14.78-8.41-15.22-12.8-.43-34.26 41.12-34.62 45.49-.32 4.2-20.89 19.16 4.7 19.16Z"
                fill="#649097"
              />
              <path
                d="M127.1 338.3H106s-.78-3.4.6-5.71c1.24-2.06.76-3.22-.15-4.9.95.4 2.19.76 3.55.68a7.45 7.45 0 0 0 3.14-1.12c.9 1.05 4.8 5.5 6.02 6.39 1.36.98 7.51.61 7.94 4.66Z"
                fill="#593F29"
              />
              <path
                d="M100.6 278.34c1.1 8.29 5.38 34.45 12.92 47.21 2.43 4.1-6.13 6.43-6.18 6.4-1.16-.3-3.06-2.14-3.94-2.95-6.13-5.57-18.6-21.36-18.6-34 0-6.17-.1-17.94 4.34-20.93 2.75-1.83 11 1 11.45 4.27Z"
                fill="#3E666C"
              />
              <path
                d="M56.3 338.73s.67-.95 1.85-2.75c1.4-2.15 2.95-6.35 4.84-11.76 4.83-11.42 8.67-16.1 13.63-20.06.9-2.24 1.87-4.5 2.88-6.76 1.83-4.03 6.84-3.48 8.61-8.04 0 0 6.97-15.8-5.83-16.24-12.8-.43-37.12 42.28-38.5 46.43-1.53 4.53-15.37 23.5 12.52 19.18Z"
                fill="#4C757B"
              />
              <path
                d="M112.6 338.3H92.34s-.75-3.13.58-5.27c1.19-1.9.73-2.97-.14-4.53.9.37 2.1.71 3.4.63a7.33 7.33 0 0 0 3.02-1.03c.87.97 4.61 5.07 5.77 5.9 1.34.9 7.24.56 7.63 4.3Z"
                fill="#593F29"
              />
              <path
                d="M60.57 323.43c1.98-5.67 12.42-14.43 15.35-21.68-.77-5.5-1.7-7.9-4.49-9.83 0 .02-15.53 20.41-10.86 31.5Z"
                fill="#4C757B"
              />
              <path
                d="M90.17 277.64c1.1 8.29 2.63 35.03 10.2 47.8 2.43 4.1-6.13 6.42-6.18 6.4-1.16-.3-3.07-2.14-3.95-2.95-6.12-5.58-16.88-28.1-16.88-40.74 0-6.18 5.47-10.71 9.94-13.7a4.47 4.47 0 0 1 6.87 3.2Z"
                fill="#4C757B"
              />
              <path d="m129.5 254.03-3.78-6.88-8.18 22.98 4.82 5.22 7.14-21.32Z" fill="#163560" />
              <path d="m109.77 258.04-7.58 21.86 20.17-4.55 7.14-21.32-19.73 4Z" fill="#2A3A54" />
              <path d="m102.58 278.81-.36-.62 7.2-20.7.35.55-7.2 20.77Z" fill="#EFDECE" />
              <path d="m109.42 257.5 19.13-3.75.95.28-19.73 4-.35-.54Z" fill="#FCECDB" />
              <path d="m129.5 254.03-4.1-6.54-2.59 7.37 5.73-1.11.96.28Z" fill="#EFDECE" />
              <path
                d="M115.6 261.2c-.66-.13-2.08-.66-3.5-1.05.43-.34.9-.74 1.03-1.17.26-.8.43-1.07-.43-.8-.84.25-3.94.8-3.94.8-1.68.5-3.4 3.67-3.4 3.67s-23.95 7.96-26.45 8.08c-3.89.18-26.37-9.92-26.37-9.92-6.1 1.35-5.16 13.23-3.06 14.59 2.09 1.34 21.13 3.83 32.15 3.96 5.59.05 25-11.61 25-11.61s3.6-1.61 5.47-1.27c1.87.33 5.85-.96 6.78-2.5.96-1.53-2.18-2.55-3.28-2.78Z"
                fill="#BC6F5B"
              />
              <path
                d="M61.38 264.24s-8.1 2.98-12.8 13.6c0 0-8.24-7.83-1.7-16.83-.02 0 4.11-5.62 14.5 3.23Z"
                fill="#EC775D"
              />
              <path
                d="M129.16 261.77c0-.2-.02-.4-.08-.6 0 0-1.87-2.98-2.48-3.11-1.87-.38-1.87 2.1-1.48 3.7a6.33 6.33 0 0 0 1.55 2.76l-.07 2.33c3.16-1.73 2.56-5.08 2.56-5.08Z"
                fill="#BC6F5B"
              />
              <path
                d="M319.8 256.14c3.43 6.12 7.79 8.5 7.79 8.5l18.17.13c-.01 0-28.58-13.3-25.96-8.63Z"
                fill="#233862"
              />
              <path
                d="M333.42 303.37c.46.55.52 1.17.27 1.8-.44 1.21-1.88 2.55-3.54 3.89-.21.17-.41.32-.56.47l-.13.11c-.04.04-.08.06-.1.1-1.57 1.43-.97 1.77-3.8 4.67-3.19 3.31-5.37 3.35-6 3.05-.53-.27.55-2.02 1.75-4l.17-.28.48-.79c1.4-2.37 1.07-3.5.75-7.06-.24-2.9-4.35-16.18-4.35-16.18l6.09-1.01s1.75 10.56 3.77 12.22c1.08.86 2.28.88 3.33 1.54l.22.13c.58.38 1.18.8 1.65 1.34Z"
                fill="#FFB27D"
              />
              <path
                d="M333.41 303.37c.47.55.53 1.17.28 1.8-.54 1.21-1.94 2.55-3.56 3.87l-.56.49c-.04.04-.1.07-.13.11-.04.04-.08.06-.1.1-1.57 1.43-.97 1.77-3.8 4.67-3.19 3.31-5.37 3.35-6 3.05-.53-.27.55-2.02 1.75-4 .62-.22 3.5-1.37 5.7-4.16 1.92-2.44 3.23-5.59 4.54-7.42l.22.13c.6.4 1.2.81 1.66 1.36Z"
                fill="#593F29"
              />
              <path
                d="M284.36 299.2c-.4 1.87-3.07 1.55-6.06.78-2.99-.75-2.28.13-6.54-.38-4.25-.5-5.52-2.1-5.66-2.74-.1-.57 2-.76 4.26-1l.86-.1c2.56-.3 4.43-1.94 6.77-3.3 2.2-1.27 5.5-6.49 5.5-6.49l5.85.5s-3.1 4.68-4.3 6.71c-.7 1.19-.67 2.8-.59 4.01 0 .64.04 1.34-.1 2Z"
                fill="#FFB27D"
              />
              <path
                d="M278.3 299.98c-2.99-.75-2.28.13-6.54-.38-4.25-.5-5.52-2.1-5.66-2.75-.1-.56 2-.75 4.26-1l.02.04s2.54 1.85 6.1 1.96c2.89.1 5.95-.71 7.95-.67a8.1 8.1 0 0 1-.06 2.01c-.4 1.88-3.08 1.56-6.07.8Z"
                fill="#593F29"
              />
              <path
                d="m307 261.7 5.36 14.85 6.99 19.4s1.92.2 3.79-.32c1.7-.49 3.68-1.77 3.68-1.77s-1.83-20.77-5.44-32.73c-.93-3.07-1.96-5.56-3.12-6.95-5.7-6.87-11.26 7.51-11.26 7.51Z"
                fill="#353B46"
              />
              <path
                d="M312.72 238.21c3.58-1.13 13.78.44 24 2.53l2.17-3.56 22.16-1.59s7.19 16.39 3.12 26.77c-.6 1.52-2.06 2.16-4.06 2.18 0 0-13.2.22-17.48.2-11-.07-23.25-7.79-24.83-8.13-2.6-.55-3.68 4.69-6.32 10.19-2.63 5.5-24.64 24.22-24.64 24.22s-3.36.02-4.74-.53c-1.5-.58-2.04-1.32-2.04-1.32s24.57-48.4 32.66-50.96Z"
                fill="#3A414D"
              />
              <path
                d="M339.04 206.07c7.85 4.43 23.79 13.62 23.88 13.56 0 0 5.87 2.28 9.21.06 5.59-3.67 8.63-13.67-1.48-22.37-5.04-4.33-8.63-5.4-9.13-12.28-.26-3.73-5.23-16.05-13.64-14.97-.7.09-1.4.15-2.11.13-.97-.04-2.6.1-4.26 1.07-4.76 2.84-14.27 33.03-2.47 34.8Z"
                fill="#6D5034"
              />
              <path
                d="M345.88 202.77c-.04.02 3.86 1.4 6.5.24 2.46-1.07 4.37-5.14 4.33-5.16-1.12-.05-2.33-1.05-3.25-7.53l-.48.17-8.04 2.84s.56 2.6.92 5.07c.31 2.1.46 4.09.02 4.37Z"
                fill="#FFBC97"
              />
              <path d="m344.94 193.35.82 4.43c4.62-.81 6.56-4.77 7.22-7.27l-8.04 2.84Z" fill="#F79565" />
              <path
                d="M343.73 195.91s10.98-1.4 10.01-8.28c-.97-6.88-.2-11.7-7.27-11.1-7.04.6-8.03 3.43-8.27 5.8-.23 2.38 2.65 13.77 5.53 13.58Z"
                fill="#FFBC97"
              />
              <path
                d="M338.63 178.57s6.99 6.16 11.75 6.69c4.78.52 6.6-1 6.6-1s-2.8-2.38-4.47-6.2a3.35 3.35 0 0 0-2.75-2.01c-3.41-.32-9.88-.51-11.13 2.52Z"
                fill="#6D5034"
              />
              <path
                d="M343.02 178.06s-2.37 2.28-3.12 3.97c-.73 1.64-.97 5.56-.41 7.12 0 0-3.6-7.19-1.52-10.67 2.25-3.7 5.05-.42 5.05-.42Z"
                fill="#6D5034"
              />
              <path
                d="M336.54 219c.16 22.4-.04 17.7 2.37 19.85.58.51 2.22.83 4.39 1 6.8.5 18.77-.55 19.24-1.8 1.6-4.38.5-5.75 1.87-12.48.15-.71.32-1.48.52-2.33 1.12-4.61 2.2-6.18-1.62-13.62-3.48-6.74-7.08-12.22-7.42-12.03-9.32 5.48-10.03.81-10.03.81s-9.42 9.68-9.32 20.6Z"
                fill="#FFE5C9"
              />
              <path
                d="m312.36 276.55 6.99 19.4s1.92.2 3.79-.32c1.7-.49 3.68-1.77 3.68-1.77s-1.83-20.77-5.44-32.73l-9.02 15.42Z"
                fill="#3A414D"
              />
              <path
                d="M345.86 198.42s-9.55 1.56-10.7 5.7c-1.17 4.15-7.93 28.44-7.93 28.44s4.84.9 7.1-1.34 7.94-20.9 7.94-20.9l3.59-11.9Z"
                fill="#FFE5C9"
              />
              <path
                d="M343.3 239.83c6.8.51 18.77-.55 19.24-1.8 1.6-4.38.5-5.75 1.87-12.47l-3.21-9.34s.46 10.37-2.58 13.08c-3.05 2.72-12.48 5.18-13.96 7.46a8.14 8.14 0 0 0-1.36 3.07Z"
                fill="#ECCBA7"
              />
              <path
                d="M351.14 235.52s-6.7-1.56-7.79-.96c-1.08.6-3.75 2.77-4.09 3.52-.33.75 2.41-.57 3.31-.8.58-.14 2.1.4 2.86.67 3.15 1.09 5.12.54 5.12.54l.6-2.97Z"
                fill="#FFBC97"
              />
              <path
                d="M355.9 197.59s9.03.62 12.12 5.03c4.35 6.21 12.88 32.62 7.86 36.08-5.66 3.92-25.61.85-25.61.85s-.64-3.15.3-4.65c.93-1.51 15.99-3.84 16.68-4.54.69-.7-8.58-13.71-8.56-15.8 0-2.07-2.78-16.97-2.78-16.97Z"
                fill="#FFE5C9"
              />
              <path
                d="M343 236.44s-1.42 1.83-1.89 2.04c-.46.2-.76.15-.76.15l.95-1.72 1.7-.47ZM343.33 234.56l-4.1 1.97s.16.29.67.27c.5-.02 1.77-.47 1.77-.47l1.66-1.77Z"
                fill="#FFB27D"
              />
              <path d="m341.99 241.43-32.38-.22-9.56-24.49 32.32.23 9.62 24.48Z" fill="#636B7E" />
              <path d="m309.24 240.25 42.76.3-.02.96-42.37-.3-.37-.97Z" fill="#444F69" />
              <path
                d="M317.87 229.06c-.24-.87.26-1.55 1.1-1.55.86 0 1.74.72 1.98 1.57.25.86-.26 1.54-1.1 1.54a2.2 2.2 0 0 1-1.98-1.56Z"
                fill="#fff"
              />
              <path d="M155.1 318.46v19.72l98.35.02v-19.72l-98.35-.02Z" fill="#FFCA28" />
              <path
                d="m155.09 338.17-14.46-6.23-8.4-3.63 8.6-3.71 14.26-6.15s1.9 4.8 1.92 9.33c.06 7.08-1.92 10.4-1.92 10.4ZM264.88 325.03v6.23a6.89 6.89 0 0 1-6.89 6.93h-4.56v-19.72h4.95c3.6.02 6.5 2.94 6.5 6.56Z"
                fill="#FCECDB"
              />
              <path d="M140.84 324.61c.35 2 .67 5.05-.21 7.33l-8.4-3.63 8.6-3.7Z" fill="#F1BB15" />
              <path d="M163.62 215.84s1.75 7.7 6.9 7.7c4.4 0 10.44-10.04 10.44-10.04l-17.34 2.34Z" fill="#F99746" />
              <path
                d="m222.58 329.66-3.3 2.28s-15.87-17.04-19.7-33.39c-.69-2.92-.95-5.8-.67-8.53l-.64-2.05-.05-.17c-.17-.57-.4-1.25-.64-2.02l-3.03-9.7c-2.76-8.85-9.11-28.83-11.82-37.13l19.49-7.1s2.2 5.08 5.4 18.9a110.2 110.2 0 0 1 2.84 14.03 125.1 125.1 0 0 1 .98 24.24c-.1 1.94.2 4.52.71 7.48 2.45 13.46 10.43 33.16 10.43 33.16Z"
                fill="#262D41"
              />
              <path
                d="M232.97 337.87h-15.75s-.6-2.52.44-4.25c.92-1.53.57-2.4-.1-3.66.7.3 1.64.57 2.65.51.78-.04 1.6-.4 2.33-.83.67.78 3.59 4.09 4.49 4.75 1.02.75 5.62.49 5.94 3.48Z"
                fill="#67472B"
              />
              <path
                d="m210.45 264.8-12.23 23c-.17-.57-.4-1.25-.64-2.02l-3.03-9.7c-2.76-8.85-9.11-28.83-11.82-37.13l19.49-7.1s2.2 5.08 5.4 18.9a112.61 112.61 0 0 1 2.84 14.05Z"
                fill="#1B212F"
              />
              <path
                d="M182.41 332.9s-1.08 2.7-.05 4.97h8.57s.19-2.05-2.93-4.42c-2.35-1.81-5.59-.55-5.59-.55Z"
                fill="#67472B"
              />
              <path
                d="M191.75 157.37c0-.44.23-5.07 7.22-5.49 0 0-3.44.5-3.98 2.04 0 0 2.3-1.94 4.22-1.38 1.92.57 3.12 3.9 3.16 5.01.03 1.11-.94 4.71-2.13 5.03-.45.13-1 .11-1.46.04.33.49.65 1.05.97 1.67 2.93 5.71.41 12.43-1.98 11.87-1.53-.36-2.45 2.3-2.45 2.3l-14.66-12.72c-.02-.01 5.12-11.4 11.1-8.38Z"
                fill="#000"
              />
              <path
                d="M182.53 195.97a18 18 0 0 0 6.22 2.68c9.58 2.24 13.26-5.94 14.64-11.55a8 8 0 0 0-3.25-1c-.69-.07-1.42-.13-2.01-.17-1.09-.83-2.7-4.23-3.05-9.5l-.45.1-7.56 2.1s.35 2.43.52 4.7c.13 1.8.15 3.5-.19 3.92l-.95.2c-.1.18-2.28 3.81-3.92 8.52Z"
                fill="#FFB27D"
              />
              <path d="M187.08 178.6s.36 2.44.52 4.72c4.28-.44 6.28-4.54 7.05-6.8l-7.57 2.09Z" fill="#ED985F" />
              <path
                d="M186.99 182.24s9.86-2.56 8.18-8.72c-1.68-6.16-1.53-10.64-7.88-9.28-6.37 1.37-6.95 4.07-6.9 6.25.08 2.2 3.98 12.26 6.6 11.75Z"
                fill="#FFB27D"
              />
              <path
                d="M179.76 167c1-2.27 2.26-2.18 3.06-1.8 4.56-4.46 9.21-1.02 9.21-1.02 1.87 4.24 5.72 5.9 5.72 5.9s-1.5 1.6-5.9 1.67a7.28 7.28 0 0 1-3.98-1.4c2.42 2.36 5.26 3.78 5.26 3.78-5.54-.93-9.41-7.3-9.8-7.97-.45.72-1.31 2.22-1.37 3.47-.05 1.7.6 4.99-.37 5.14.02 0-3.34-4.35-1.83-7.76Z"
                fill="#000"
              />
              <path
                d="M184.15 186.95s16.55-4.05 23.76 1.94l-3.6 50.58-32.4-7.89s.92-3.2 7.12-11.71c6.22-8.51 3.53-21 5.12-32.92Z"
                fill="#FFB27D"
              />
              <path
                d="m193.81 233.84-.06.5-.05.5-.75 7.1c-.9 8.59-2.28 22.36-3.23 33.24-.75 8.51-1.22 15.24-.96 16.3.77 3.27 0 42.14 0 42.14-2.74 1.33-6.93 0-6.93 0s-7.32-35.03-6.31-39.9c1.03-4.89-.7-9.03-.7-9.03-5.69-26.72-5.05-41.54-3.93-48.63.33-2.07.7-3.46.97-4.33.22-.73.39-1.07.39-1.07 12.57-3.39 21.56 3.18 21.56 3.18Z"
                fill="#262D41"
              />
              <path
                d="M210.14 203.32c-.8 6.08-4 13.54-5.14 17.55 0 0 1.9 13.91.1 17.74-.21.43-.47.73-.8.88-6.74 2.96-33.04.1-34.16-8.47-.41-3.1 10.01-14.03 10.63-15.37.26-.55.52-2.33-.71-6-1.74 5.38-11.28 3.84-11.28 3.84 1.12-1.95 3.92-15.33 7.04-21.38 2.35-4.54 8.61-5.2 8.61-5.2s2.62 4.16 8.91 3.58c6.32-.58 7.46-4.48 7.46-4.48s5.58.75 7.32 2.15c.3.22 3.08 7.17 2.02 15.16Z"
                fill="#47979D"
              />
              <path
                d="M205 220.85s1.9 13.92.09 17.74c-4.91-2.49-8.8-9.23-7.9-16.72.65-5.54 1.64-6.82 4.6-9.99 2.16-2.33 7.15-2.46 6.76-1.35-1.16 3.31-2.94 8.2-3.55 10.32Z"
                fill="#3E8388"
              />
              <path d="m184.47 204.39 11.28 18.25h-19.18l-10.76-17.86 18.66-.4Z" fill="#2D4048" />
              <path d="m195.15 221.72.2-.65-10.68-17.25-.2.57 10.68 17.33Z" fill="#EFDECE" />
              <path d="m184.67 203.82-18.06.51-.8.45 18.66-.4.2-.56Z" fill="#FCECDB" />
              <path d="m165.8 204.78-10.12-5.51 11.8 18.7 9.09 4.67-10.77-17.86Z" fill="#394E57" />
              <path
                d="M219.48 217.57c-1.09.51-3.87 3.8-4.88 4.15-4.46 1.5-23.52-2.51-23.52-2.51l.6-3.37s18.68.5 20.74-.06c.39-.11 2.4-3.3 3.17-3.75l3.89 5.54Z"
                fill="#FFB27D"
              />
              <path
                d="M191.68 215.84s-2.26-1.85-3.78-1.43c-1.53.41-3.75 2.35-4.6 2.82-.83.45-3.1 2.11-1.94 3.11 1.14 1 4.71.13 6.13-.62s3.6-.51 3.6-.51l.59-3.37Z"
                fill="#FFB27D"
              />
              <path
                d="M188.34 214.35s-2.75-.32-3.5-.32c-.75.02-.54.19-.13.77.41.59 1.83.81 1.9 1.02.08.2 1.73-1.47 1.73-1.47Z"
                fill="#FFB27D"
              />
              <path
                d="M200.81 185.99s8.13.98 10.35 4.48c2.82 4.45 9.51 22.13 9.29 26.57 0 0-4.88 8.37-21.62 7.03 0 0-1.73-6.2 1.78-8.25 0 0 8.6-1.54 9.58-2.41l-7-12.84-2.38-14.58Z"
                fill="#47979D"
              />
              <path
                d="M168.42 211.45c-.24-1.03-2.49-.4-3.23.2-.19.16-.38.4-.58.69l-.06-.47c-.04-.5-.6-1.36-.75-.7-.13.66-.37 3.37-.37 3.37-.02 2.2 1.38 3.1 2.28 2.4.9-.7 2.95-4.45 2.7-5.49Z"
                fill="#FFB27D"
              />
              <path
                d="M475.35 339.64H.65a.66.66 0 0 1-.65-.66v-.43c0-.36.3-.66.65-.66h474.7c.35 0 .65.3.65.66v.43c0 .36-.3.66-.65.66Z"
                fill="#E9E9E9"
              />
            </svg>
          </div>
          <div class="help-text"> As Seen In: </div>
          <div class="reference-wrap">
            <a
              href="https://www.forbes.com/sites/avivalegatt/2020/03/24/7-essential-college-admissions-resources-during-coronavirus-2020/#3be7088e34a6"
              target="_blank"
              class="reference-item"
            >
              <img src="../../../../../../../assets/img/seen-in/forbes.png" class="img-fluid" />
            </a>
            <a href="https://www.asugsvsummit.com/gsv-cup-elite-200" target="_blank" class="reference-item">
              <img src="../../../../../../../assets/img/seen-in/asu.png" class="img-fluid" />
            </a>
            <a
              href="https://www.appoftheday.downloadastro.com/app/roundpier-high-school-and-college-app"
              target="_blank"
              class="reference-item"
            >
              <img src="../../../../../../../assets/img/seen-in/app-of-the-day.png" class="img-fluid" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="cards">
    <div class="container">
      <div class="card-wrap">
        <div class="row">
          <div class="col-12 col-lg-4">
            <div class="card-item" (click)="onStudent(); false">
              <div class="card-item-icon">
                <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M32 43.73 8.35 48.27c-3.01.58-5.15 2.81-5.15 5.39v8.5c0 1.02 1 1.84 2.22 1.84h53.16c1.23 0 2.22-.82 2.22-1.84v-8.5c0-2.58-2.14-4.8-5.15-5.39L32 43.73Z"
                    fill="#FFCA28"
                  />
                  <path d="M40.83 35.31H23.17v12.14h17.66V35.3Z" fill="#E6B47D" />
                  <path d="M23.17 35.31v9c10.45 1.37 17.66-7.9 17.66-7.9v-1.1H23.17Z" fill="#D2A073" />
                  <path
                    d="M32.07 61.87c-1.21 0-2.2-1.22-2.2-2.72l-3.2-12.22h10.66l-3.05 12.22c0 1.5-.99 2.72-2.2 2.72Z"
                    fill="#FFECB4"
                  />
                  <path
                    d="M23.17 42.67 32 51.49s-3.6.9-6.74 4.33a.9.9 0 0 1-1.52-.3l-3.58-9.83a1.1 1.1 0 0 1 .42-1.3l2.6-1.72ZM40.83 42.67 32 51.49s3.6.9 6.74 4.33a.9.9 0 0 0 1.53-.3l3.57-9.83a1.1 1.1 0 0 0-.42-1.3l-2.6-1.72Z"
                    fill="#FFF1C7"
                  />
                  <path
                    d="M32 59.95a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2ZM32 55.54a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2Z"
                    fill="#F7C52C"
                  />
                  <path
                    d="M47.59 22.73v-7.8H17.07V34c0 2.59 1.17 5 3.13 6.44l5.66 4.14a6.6 6.6 0 0 0 3.9 1.3h5.13a6.6 6.6 0 0 0 3.9-1.3l5.66-4.14a7.96 7.96 0 0 0 3.14-6.44v-2.37a3.21 3.21 0 0 0 2.54-3.15v-2.58c0-1.56-1.09-2.86-2.54-3.16Z"
                    fill="#F0C891"
                  />
                  <path
                    d="M24.26 20.95c4.23.75 11.78 1.72 22.67 1.72v-7.74H16.41v7.8a3.21 3.21 0 0 0-2.54 3.16v2.58c0 1.56 1.09 2.86 2.54 3.15V34c0 2.59 1.18 5 3.14 6.44l5.65 4.14a6.6 6.6 0 0 0 3.9 1.3h1.3c-1.86 0-5.07-4.81-6.67-7.4a6.49 6.49 0 0 1-.96-3.42V22.22c0-.8.7-1.4 1.49-1.27Z"
                    fill="#E6B47D"
                  />
                  <path
                    d="M30.72 0c-8.96 0-10.24 3.84-10.24 3.84-5.12 0-7.68 1.28-7.68 6.4 0 3.44 1.28 14.08 1.28 14.08l2.56 1.28 2.39-8.97s11.69 3.85 27.05 3.85l1.28 5.12 2.56-1.28s1.28-7.68 1.28-12.8C51.2 3.84 40.96 0 30.72 0Z"
                    fill="#8C6450"
                  />
                  <path
                    d="M20.43 4.27c-5.09 0-7.63 1.25-7.63 6.27 0 3.37 1.27 13.8 1.27 13.8l2.55 1.26 2.37-8.8s11.62 3.78 26.88 3.78C28.07 16.82 20.43 8.03 20.43 4.27Z"
                    fill="#7D5541"
                  />
                  <path
                    d="M32 37.57a9.17 9.17 0 0 1-5.02-1.32 1.1 1.1 0 1 1 1.23-1.82c.87.59 2.29.94 3.8.94 1.5 0 2.91-.35 3.78-.94a1.1 1.1 0 1 1 1.24 1.82A9.17 9.17 0 0 1 32 37.57Z"
                    fill="#966D50"
                  />
                  <path
                    d="M25.87 28.94c-.9 0-1.65-.74-1.65-1.65v-1.1a1.65 1.65 0 0 1 3.3 0v1.1c0 .9-.73 1.65-1.65 1.65ZM38.13 28.94c-.92 0-1.66-.74-1.66-1.65v-1.1a1.65 1.65 0 0 1 3.3 0v1.1c0 .9-.73 1.65-1.64 1.65Z"
                    fill="#5A4137"
                  />
                </svg>
              </div>
              <div class="card-item-title">I'm a student</div>
              <div class="card-item-desc">
                Discover extracurricular opportunities, explore college and career options
              </div>
              <div class="card-item-link">
                <svg viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.8 13.6 8.2 8 1.8 2.4" stroke="#fff" stroke-width="3" stroke-linecap="round" />
                </svg>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="card-item" (click)="onEducator(); false">
              <div class="card-item-icon">
                <svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M30 41 7.83 45.25C5 45.8 3 47.9 3 50.3v7.97c0 .96.93 1.73 2.08 1.73h49.84c1.15 0 2.08-.77 2.08-1.73V50.3c0-2.4-2-4.5-4.83-5.05L30 41Z"
                    fill="#F8DCBF"
                  />
                  <path d="M38.28 33.1H21.72v11.38h16.56V33.1Z" fill="#E6B47D" />
                  <path d="M21.72 33.1v8.45c9.8 1.28 16.56-7.41 16.56-7.41V33.1H21.72Z" fill="#D2A073" />
                  <path
                    d="M30.07 58C28.93 58 28 56.86 28 55.45L25 44h10l-2.86 11.45c0 1.4-.93 2.55-2.07 2.55Z"
                    fill="#BE1931"
                  />
                  <path
                    d="M32.8 53.17s.8-1.67 1.13-2.42c.4-.87.97-4.18.97-4.18L30.22 44c0-.02-.35.01-.35.01l-.4.11-.36.17c-.47.18.2.02.2.04l-4.23 2.23s.61 3.3 1 4.18c.34.75 1.14 2.42 1.14 2.42S25.6 54.67 25 60h10c-.6-4.25-2.2-6.83-2.2-6.83Z"
                    fill="#BB2538"
                  />
                  <path
                    d="M29.96 46c.77-.05 3.07 2.03 2.83 3.3-.92 4.81-1.7 3.66-2.77 3.66-1.21 0-1.92 1.25-2.76-3.46-.19-1.02 1.58-3.41 2.7-3.5ZM34 60h-8s1.08-5.7 4.01-5.7C32.95 54.3 34 60 34 60Z"
                    fill="#DD2E44"
                  />
                  <path
                    d="M21.85 40 30 48s-3.33 1.4-6.22 4.7a.82.82 0 0 1-1.41-.27l-3.3-9.51c-.17-.46 0-.98.38-1.25l2.4-1.67ZM38.15 40 30 48s3.33 1.4 6.22 4.7a.82.82 0 0 0 1.41-.27l3.3-9.51c.17-.46 0-.98-.38-1.25L38.15 40Z"
                    fill="#F5F8FA"
                  />
                  <path d="M34.09 44h-8.17L30 48l4.09-4Z" fill="#D6DDE1" />
                  <path
                    d="M44.62 21.31V14H16v17.87c0 2.42 1.1 4.69 2.94 6.03l5.3 3.88A6.2 6.2 0 0 0 27.9 43h4.81a6.2 6.2 0 0 0 3.66-1.22l5.3-3.88a7.46 7.46 0 0 0 2.95-6.03v-2.22A3.01 3.01 0 0 0 47 26.69v-2.42a3.01 3.01 0 0 0-2.38-2.96Z"
                    fill="#F0C891"
                  />
                  <path
                    d="m35.45 32.14 1.85.5c.51.2.8.74.66 1.38-.12.54-.5.82-.92.82-.09 0-.18-.05-.26-.08l-1.86-.69c.1.18.17.4.2.62 0 .22-.02.44-.1.64-.12.29-.32.5-.56.6-.24.11-.5.08-.73-.06l-1.51-.96c-.02.2-.07.4-.16.56-.09.17-.2.3-.35.4a.81.81 0 0 1-.43.13c-.35 0-.51-.25-.68-.68l.08-.25-.1.25c-.08.2-.2.38-.35.5a.82.82 0 0 1-.51.18.84.84 0 0 1-.64-.32c-.17-.2-.28-.48-.3-.77l-1.51.96a.78.78 0 0 1-.73.07c-.24-.1-.44-.32-.56-.6a1.47 1.47 0 0 1 .1-1.27l-1.86.7c-.08.02-.17.07-.26.07-.42 0-.8-.28-.92-.82-.15-.64.15-1.19.66-1.37l1.85-.51c.6-.18 1.72-.14 2.25-.14h5.4c.53 0 1.66-.04 2.25.14Z"
                    fill="#73615C"
                  />
                  <path
                    d="M21.74 17.64c3.97.7 11.05 1.61 21.26 1.61L44 13H15.38v8.31A3.01 3.01 0 0 0 13 24.27v2.42a3.01 3.01 0 0 0 2.38 2.96v2.22c0 2.42 1.1 4.69 2.95 6.03l5.3 3.88A6.2 6.2 0 0 0 27.29 43h1.21c-1.74 0-5.75-6.5-7.25-8.94-.6-.96-.9-2.06-.9-3.2V18.83c0-.75.66-1.32 1.4-1.19Z"
                    fill="#E6B47D"
                  />
                  <path
                    d="M48 16.4C48 8.95 41.08 0 30 0 17.54 0 12 8.95 12 16.4c0 7.46 2.38 9.53 2.77 7.46 1.38-7.46 5.54-10.44 5.54-10.44 8.3 7.46 6.92 1.49 6.92 1.49 8.31 8.95 4.16 0 4.16 0 2.77 2.98 11.07 2.98 11.07 2.98l2.77 5.97c1.39 2.98 2.77 0 2.77-7.46Z"
                    fill="#73615C"
                  />
                  <path
                    d="M24.26 27.13c-.86 0-1.55-.7-1.55-1.55v-1.03a1.55 1.55 0 0 1 3.1 0v1.03c0 .86-.7 1.55-1.55 1.55ZM35.74 27.13c-.85 0-1.54-.7-1.54-1.55v-1.03a1.55 1.55 0 0 1 3.1 0v1.03c0 .86-.7 1.55-1.56 1.55Z"
                    fill="#5A4137"
                  />
                </svg>
              </div>
              <div class="card-item-title">I'm an educator</div>
              <div class="card-item-desc">
                Use our platform to manage clubs, introduce new programs and bring students to our competitions
              </div>
              <div class="card-item-link">
                <svg viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.8 13.6 8.2 8 1.8 2.4" stroke="#fff" stroke-width="3" stroke-linecap="round" />
                </svg>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="card-item" (click)="onOrganization(); false">
              <div class="card-item-icon">
                <svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M58 21.5H2V58h56V21.5Z" fill="#EBF0F3" />
                  <path d="M58.06 21.5H1.95L5.97 7h48.06l4.03 14.5Z" fill="#EE6A5A" />
                  <path d="M30 10 14 26h32L30 10Z" fill="#D66151" />
                  <path d="M46 54H14v3h32v-3Z" fill="#93A8B8" />
                  <path d="M58.5 57h-57a1.5 1.5 0 0 0 0 3h57a1.5 1.5 0 0 0 0-3Z" fill="#7B93A6" />
                  <path d="M20 28h-3v24h3V28Z" fill="#D5D6DB" />
                  <path d="M21 26h-5v2h5v-2Z" fill="#64798A" />
                  <path d="M43 28h-3v24h3V28Z" fill="#D5D6DB" />
                  <path d="M44 26h-5v2h5v-2ZM21 52h-5v2h5v-2ZM44 52h-5v2h5v-2Z" fill="#64798A" />
                  <path d="M34 32h-8a1 1 0 0 0-1 1v21h10V33a1 1 0 0 0-1-1Z" fill="#DAA162" />
                  <path d="M12.33 32H7v5.95h5.33V32Z" fill="#D5D6DB" />
                  <path d="M11.79 32.54H7.55v4.87h4.24v-4.87Z" fill="#7AD0F7" />
                  <path d="M12.33 43.9H7v5.95h5.33V43.9Z" fill="#D5D6DB" />
                  <path d="M11.79 44.44H7.55v4.87h4.24v-4.87Z" fill="#7AD0F7" />
                  <path d="M52.33 32H47v5.95h5.33V32Z" fill="#D5D6DB" />
                  <path d="M51.79 32.54h-4.24v4.87h4.24v-4.87Z" fill="#7AD0F7" />
                  <path d="M52.33 43.9H47v5.95h5.33V43.9Z" fill="#D5D6DB" />
                  <path d="M51.79 44.44h-4.24v4.87h4.24v-4.87Z" fill="#7AD0F7" />
                  <path fill="#D29B5D" d="M29 32h2v22h-2z" />
                </svg>
              </div>
              <div class="card-item-title">I'm an organization</div>
              <div class="card-item-desc">
                Introduce your institution, organization or program to our unique community
              </div>
              <div class="card-item-link">
                <svg viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.8 13.6 8.2 8 1.8 2.4" stroke="#fff" stroke-width="3" stroke-linecap="round" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-4 col-xl-3">
          <div class="section-title mb-3">
            <div class="alt">Explore topics</div>
            and opportunities for you
          </div>
        </div>
        <div class="col-12 col-lg-8 col-xl-9">
          <div class="chip-wrap pl-lg-1">
            <a [href]="'/eduniverse?program=summercamps' | appBaseUrl" class="chip-item" target="_blank">
              Summer Programs
            </a>
            <a [href]="'/eduniverse?program=jobs' | appBaseUrl" class="chip-item" target="_blank">
              Internships & Volunteering
            </a>
            <a
              [href]="'/discussions/256/rp-insights:-applying-to-the-us-colleges-as-an-international-student' | appBaseUrl"
              class="chip-item"
              target="_blank"
            >
              International Students
            </a>
            <a href="https://colleges.roundpier.com/" class="chip-item" target="_blank"> College Search </a>
            <a
              [href]="'/discussions/303/colleges-that-meet-full-financial-need' | appBaseUrl"
              class="chip-item"
              target="_blank"
            >
              Financial Aid
            </a>
            <a [href]="'/groups/clubs' | appBaseUrl" class="chip-item" target="_blank"> School Clubs </a>
            <a [href]="'/groups/competitions' | appBaseUrl" class="chip-item" target="_blank"> Competitions </a>
            <a
              [href]="'/discussions/144/rp-insights:-merit-scholarships' | appBaseUrl"
              class="chip-item"
              target="_blank"
            >
              Scholarships
            </a>
            <a [href]="'/groups/47/medicine' | appBaseUrl" class="chip-item" target="_blank"> Medicine </a>
            <a [href]="'/groups/9/entrepreneurship' | appBaseUrl" class="chip-item" target="_blank">
              Entrepreneurship
            </a>
            <a [href]="'/groups/6/studying-in-europe' | appBaseUrl" class="chip-item" target="_blank">
              Studying Abroad
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-4 col-xl-3 order-0 order-lg-1">
          <div class="section-title mb-3">
            <div class="alt">Register your club</div>
            to participate in our events
          </div>
          <div class="section-desc mb-4">
            Join our competitions and bring your club into our unique global community.
          </div>
          <a [href]="'/groups/clubs' | appBaseUrl" target="_blank" class="button d-inline-block">Explore</a>
        </div>
        <div class="col-12 col-lg-8 col-xl-9 order-lg-0 order-1">
          <div class="card-club-wrap">
            <a
              [href]="'/groups/competitions/51/RoundPier%20Entrepreneurship%20and%20Nonprofit%20Competition%202022' | appBaseUrl"
              class="card-club-item"
              target="_blank"
            >
              <div class="card-club-item-image">
                <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#entrepreneurship)">
                    <path
                      d="M36.174 64h-8.35a6.269 6.269 0 0 1-6.261-6.262v-9.741c0-1.154.935-2.088 2.087-2.088h16.699c1.152 0 2.087.934 2.087 2.088v9.74A6.269 6.269 0 0 1 36.174 64Z"
                      fill="#DBE1E5"
                    />
                    <path
                      d="M40.35 45.91H32V64h4.174a6.269 6.269 0 0 0 6.263-6.262v-9.741a2.087 2.087 0 0 0-2.088-2.088Z"
                      fill="#C9D3D9"
                    />
                    <path
                      d="M46.486 5.136C42.366 1.782 37.274.015 32 0a22.866 22.866 0 0 0-4.927.5C18.07 2.382 10.96 9.757 9.386 18.886c-1.53 8.934 2.074 17.687 9.421 22.864 1.754 1.224 2.756 3.005 2.756 4.884v3.451h20.874v-3.187c0-2.031 1.043-3.938 2.88-5.246 6.04-4.314 9.644-11.3 9.644-18.703 0-6.944-3.09-13.443-8.475-17.812Z"
                      fill="#FFE359"
                    />
                    <path
                      d="M54.96 22.948c0 7.404-3.604 14.39-9.643 18.703-1.837 1.308-2.88 3.215-2.88 5.247v3.186H32V.001c5.274.014 10.367 1.781 14.486 5.135 5.385 4.37 8.475 10.868 8.475 17.812Z"
                      fill="#FFCA28"
                    />
                    <path
                      d="M34.087 31.297v18.787h-4.175V31.297c0-1.155.933-2.087 2.088-2.087s2.087.932 2.087 2.087Z"
                      fill="#FFC033"
                    />
                    <path
                      d="M32 33.385a6.269 6.269 0 0 1-6.263-6.262A6.27 6.27 0 0 1 32 20.86a6.269 6.269 0 0 1 6.262 6.262A6.269 6.269 0 0 1 32 33.386Zm0-8.35a2.09 2.09 0 0 0-2.088 2.087A2.09 2.09 0 0 0 32 29.21a2.09 2.09 0 0 0 2.087-2.088A2.09 2.09 0 0 0 32 25.035Z"
                      fill="#FFC033"
                    />
                    <path
                      d="M19.475 25.036a2.088 2.088 0 0 0 2.088-2.088c0-5.755 4.681-10.436 10.436-10.436a2.088 2.088 0 0 0 0-4.175c-8.057 0-14.611 6.555-14.611 14.611 0 1.154.935 2.088 2.087 2.088Z"
                      fill="#fff"
                    />
                    <path
                      d="M34.087 10.423a2.087 2.087 0 0 0-2.088-2.087v4.175a2.088 2.088 0 0 0 2.088-2.088Z"
                      fill="#fff"
                    />
                    <path d="M34.087 50.084V31.297a2.084 2.084 0 0 0-2.088-2.087v20.874h2.088Z" fill="#F9A926" />
                    <path
                      d="M34.087 27.122a2.09 2.09 0 0 1-2.088 2.088v4.175a6.269 6.269 0 0 0 6.263-6.262A6.269 6.269 0 0 0 32 20.86v4.175a2.09 2.09 0 0 1 2.087 2.087Z"
                      fill="#F9A926"
                    />
                  </g>
                  <defs>
                    <clipPath id="entrepreneurship">
                      <path fill="#fff" d="M0 0h64v64H0z" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <span class="card-club-item-title">Entrepreneurship</span>
              <span href="#" class="card-item-link">
                <svg viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.8 13.6 8.2 8 1.8 2.4" stroke="#fff" stroke-width="3" stroke-linecap="round" />
                </svg>
              </span>
            </a>
            <a
              [href]="'/groups/competitions/54/RoundPier%20Investment%20Competition%202022%2F2023' | appBaseUrl"
              class="card-club-item"
              target="_blank"
            >
              <div class="card-club-item-image">
                <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M57.04 64H6.96A6.96 6.96 0 0 1 0 57.04V6.96A6.96 6.96 0 0 1 6.96 0h50.08A6.96 6.96 0 0 1 64 6.96v50.08A6.96 6.96 0 0 1 57.04 64Z"
                    fill="#F1F9FD"
                  />
                  <path
                    d="M57.04 0H32v64h25.04A6.96 6.96 0 0 0 64 57.04V6.96A6.96 6.96 0 0 0 57.04 0Z"
                    fill="#E5F1F7"
                  />
                  <path
                    d="m54.12 12.8-8.35 6.26-8.34 6.26c-.63.48-1.48.56-2.19.2L32 23.9l-3.95-1.97-15.67 11.74a2.08 2.08 0 0 1-2.92-.42c-.7-.92-.5-2.22.42-2.92l16.7-12.52a2.07 2.07 0 0 1 2.18-.2L32 19.23l3.95 1.97L51.62 9.46a2.09 2.09 0 0 1 2.5 3.34Z"
                    fill="#FF3501"
                  />
                  <path
                    d="M54.96 64V23.65a2.09 2.09 0 0 0-4.18 0V64h4.18ZM46.6 64V29.91a2.09 2.09 0 0 0-4.17 0V64h4.18ZM38.26 64V36.17a2.09 2.09 0 0 0-4.17 0V64h4.17ZM29.91 64V32a2.09 2.09 0 0 0-4.17 0v32h4.17ZM21.57 64V38.26a2.09 2.09 0 0 0-4.18 0V64h4.18ZM13.22 64V44.52a2.09 2.09 0 0 0-4.18 0V64h4.18Z"
                    fill="#7AD0F6"
                  />
                </svg>
              </div>
              <span class="card-club-item-title">Investment</span>
              <span class="card-item-link">
                <svg viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.8 13.6 8.2 8 1.8 2.4" stroke="#fff" stroke-width="3" stroke-linecap="round" />
                </svg>
              </span>
            </a>
            <a
              [href]="'/groups/competitions/27/RoundPier%20Scriptwriting%20Competition%202022' | appBaseUrl"
              class="card-club-item"
              target="_blank"
            >
              <div class="card-club-item-image">
                <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M62 58a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V12h14l-6 6h8l6-6h8l-6 6h8l6-6h8l-6 6h8l6-6h6v46ZM50 2h8a4 4 0 0 1 4 4v2h-6l-6-6ZM40 8l-6-6h8l6 6h-8ZM24 8l-6-6h8l6 6h-8ZM2 8V6a4 4 0 0 1 4-4h4l6 6H2Zm24.01 39.7a1.21 1.21 0 0 0 .77 1.09 1.47 1.47 0 0 0 1.47-.09l13.15-8.66a1.38 1.38 0 0 0 .46-1.81c-.11-.2-.27-.37-.47-.5L28.21 29.2a1.46 1.46 0 0 0-1.47-.07 1.3 1.3 0 0 0-.76 1.17l.03 17.4Z"
                    fill="#7B93A6"
                  />
                </svg>
              </div>
              <span class="card-club-item-title">Screenwriting</span>
              <span class="card-item-link">
                <svg viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.8 13.6 8.2 8 1.8 2.4" stroke="#fff" stroke-width="3" stroke-linecap="round" />
                </svg>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-4">
          <div class="section-title mb-3">
            <div class="alt">Interact with</div>
            leading organizations
          </div>
          <div class="section-desc mb-3 mb-lg-0">
            Discover summer & after school programs, jobs, internships as well as volunteering and tutoring
            opportunities.
          </div>
        </div>
        <div class="col-12 col-lg-8">
          <div class="organisation-wrap">
            <ngx-slick-carousel [config]="suggestedSlideConfig">
              <a
                [href]="'/_ldl/the-diamond-challenge' | appBaseUrl"
                target="_blank"
                class="organisation-item"
                ngxSlickItem
              >
                <div class="organisation-item-image">
                  <img src="../../../../../../../assets/img/orgs/10.png" alt="" />
                </div>
                <span class="organisation-item-title">The Diamond Challenge</span>
              </a>
              <a
                [href]="'/_lbfhf/yale-young-global-scholars' | appBaseUrl"
                target="_blank"
                class="organisation-item"
                ngxSlickItem
              >
                <div class="organisation-item-image">
                  <img src="../../../../../../../assets/img/orgs/12.png" alt="" />
                </div>
                <span class="organisation-item-title">Yale Young Global Scholars</span>
              </a>
              <a
                [href]="'/_mfddk/lumiere-education' | appBaseUrl"
                target="_blank"
                class="organisation-item"
                ngxSlickItem
              >
                <div class="organisation-item-image">
                  <img src="../../../../../../../assets/img/orgs/11.png" alt="" />
                </div>
                <span class="organisation-item-title">Lumiere Education</span>
              </a>
              <a [href]="'/_fhd/launchx' | appBaseUrl" target="_blank" class="organisation-item" ngxSlickItem>
                <div class="organisation-item-image">
                  <img src="../../../../../../../assets/img/orgs/4.png" alt="" />
                </div>
                <span class="organisation-item-title">LaunchX</span>
              </a>
              <a [href]="'/_ccfl/fcb.escola' | appBaseUrl" target="_blank" class="organisation-item" ngxSlickItem>
                <div class="organisation-item-image">
                  <img src="../../../../../../../assets/img/orgs/5.png" alt="" />
                </div>
                <span class="organisation-item-title">FCB Escola</span>
              </a>
              <a
                [href]="'/_chdf/draper.high.school.internship.program' | appBaseUrl"
                target="_blank"
                class="organisation-item"
                ngxSlickItem
              >
                <div class="organisation-item-image">
                  <img src="../../../../../../../assets/img/orgs/6.png" alt="" />
                </div>
                <span class="organisation-item-title">Draper High School Internship Program</span>
              </a>
              <a [href]="'/_hgl/pau.gasol.academy' | appBaseUrl" target="_blank" class="organisation-item" ngxSlickItem>
                <div class="organisation-item-image">
                  <img src="../../../../../../../assets/img/orgs/7.png" alt="" />
                </div>
                <span class="organisation-item-title">Pau Gasol Academy</span>
              </a>
              <a
                [href]="'/_llk/new.jersey.center.for.teaching.26.learning.28ctl.29' | appBaseUrl"
                target="_blank"
                class="organisation-item"
                ngxSlickItem
              >
                <div class="organisation-item-image">
                  <img src="../../../../../../../assets/img/orgs/9.png" alt="" />
                </div>
                <span class="organisation-item-title">New Jersey Center for Teaching & Learning (CTL)</span>
              </a>
            </ngx-slick-carousel>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="container">
      <div class="testimonial-wrap">
        <ngx-slick-carousel [config]="suggestedSlideConfig">
          <div class="testimonial-item" ngxSlickItem>
            <div class="testimonial-item-text">
              RoundPier has helped me connect with girls all over the world to help me start Girl Genius Magazine. In
              addition, RoundPier has always shown support for my organization by reposting it and sending emails to its
              many members.
            </div>
            <div class="d-flex mt-4">
              <div class="testimonial-item-avatar">
                <img src="../../../../../../../assets/img/users/user-1.png" alt="" />
              </div>
              <div>
                <div class="testimonial-item-name">Shivali G.</div>
                <div class="testimonial-item-position">US Student</div>
              </div>
            </div>
          </div>
          <div class="testimonial-item" ngxSlickItem>
            <div class="testimonial-item-text">
              I saved a lot of time on finding ECs and connecting with other students and organizations. RoundPier is a
              great tool for discovering new opportunities to get involved in.
            </div>
            <div class="d-flex mt-4">
              <div class="testimonial-item-avatar">
                <img src="../../../../../../../assets/img/users/user-2.png" alt="" />
              </div>
              <div>
                <div class="testimonial-item-name">Sam Y.</div>
                <div class="testimonial-item-position">US Student</div>
              </div>
            </div>
          </div>
          <div class="testimonial-item" ngxSlickItem>
            <div class="testimonial-item-text">
              I am greatly thankful for the amazing resources on this website. All in all, RoundPier was one of the most
              useful tools in my college application experience. Thank you.
            </div>
            <div class="d-flex mt-4">
              <div class="testimonial-item-avatar">
                <img src="../../../../../../../assets/img/users/user-3.png" alt="" />
              </div>
              <div>
                <div class="testimonial-item-name">Srihari B.</div>
                <div class="testimonial-item-position">International student</div>
              </div>
            </div>
          </div>
          <div class="testimonial-item" ngxSlickItem>
            <div class="testimonial-item-text">
              I use RoundPier to network with like-minded peers from around the globe to share ideas and opportunities,
              explore and learn!
            </div>
            <div class="d-flex mt-4">
              <div class="testimonial-item-avatar">
                <img src="../../../../../../../assets/img/users/_thumb_19072.jpg" alt="" />
              </div>
              <div>
                <div class="testimonial-item-name">Ashley L.</div>
                <div class="testimonial-item-position">US Student</div>
              </div>
            </div>
          </div>
          <div class="testimonial-item" ngxSlickItem>
            <div class="testimonial-item-text">
              I really liked RoundPier's platform due to variety of extracurricular opportunities offered and
              personalized college list that was built using my current profile.
            </div>
            <div class="d-flex mt-4">
              <div class="testimonial-item-avatar">
                <img src="../../../../../../../assets/img/users/_thumb_18040.jpg" alt="" />
              </div>
              <div>
                <div class="testimonial-item-name">Tanya</div>
                <div class="testimonial-item-position">US Student</div>
              </div>
            </div>
          </div>
          <div class="testimonial-item" ngxSlickItem>
            <div class="testimonial-item-text">
              Great app for parents and kids, tons of useful and much needed information at your fingertips.
            </div>
            <div class="d-flex mt-4">
              <div class="testimonial-item-avatar">
                <img src="../../../../../../../assets/img/users/_thumb_18041.jpg" alt="" />
              </div>
              <div>
                <div class="testimonial-item-name">Katherine</div>
                <div class="testimonial-item-position">US Parent</div>
              </div>
            </div>
          </div>
        </ngx-slick-carousel>
      </div>
    </div>
  </section>
  <section class="join">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-4 pr-lg-0">
          <div class="section-title mb-4">
            <div class="alt">Join your</div>
            classmates, teachers, and friends on RoundPier!
          </div>
          <a href="" class="button d-inline-block" (click)="onGetStarted(); false">Get started</a>
        </div>
      </div>
    </div>
  </section>
</main>
